<iframe
    [src]="iFrameUrl | noResSanitize"
    class="border-0 h-full w-full"></iframe>
